import { Set } from "immutable";

import createModel from "../../createModel";

export const MutualFundsRegularAvailableFundsProfileChange = createModel("MutualFundsRegularAvailableFundsProfileChange", (json) => ({
    isinList: Set(json.isinList),
}));
